import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Alert } from 'reactstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import FormCard from '../forms/FormCard';
import { getNovertejumsColor, parseListResult } from './riskaNovertejumsUtils';
import { loadRiskaNovertejumaParametri } from '../../actions/dzeramaUdensSatecesBaseiniActions';

class RiskaNovertejumsParametri extends Component {
    state = {
        parametriList: []
    };

    componentDidMount() {
        this.loadParametri();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.id !== this.props.id) {
            this.loadParametri();
        }
    }

    loadParametri = () => {
        const { id, loadRiskaNovertejumaParametri } = this.props;
        if (id) {
            loadRiskaNovertejumaParametri(id).then(result => {
                this.setState({ parametriList: parseListResult(result) });
            }).catch(() => {});
        }
    }

    render() {
        const { objekti } = this.props;
        const { parametriList } = this.state;

        if (!objekti || objekti.length === 0) {
            return (
                <FormCard title="Monitoringa parametri" size={12}>
                    <Alert color="info">Nav riska objektu</Alert>
                </FormCard>
            );
        }

        const parametriByKat = {};
        parametriList.forEach(p => {
            const katId = p.riska_novertejuma_kategorijas_id;
            if (!parametriByKat[katId]) parametriByKat[katId] = [];
            parametriByKat[katId].push(p.riska_parametrs_nosaukums);
        });

        const kategorijasWithStats = objekti.map(kat => ({
            id: kat.id,
            nosaukums_display: kat.nosaukums_display,
            objektuSkaits: kat.riska_objekti?.length || 0,
            maksNovertejums: kat.novertejums || 0,
            parametri: (parametriByKat[kat.id] || []).join(', ') || '-'
        }));

        const obligatas = kategorijasWithStats.filter(k => k.maksNovertejums >= 10);
        const rekomendetasKat = kategorijasWithStats.filter(k => k.maksNovertejums < 10);

        const parametriColumns = [
            {
                dataField: 'nosaukums_display',
                text: 'Kategorija',
                formatter: (cell) => <strong>{cell}</strong>,
                headerStyle: { width: '15%' }
            },
            {
                dataField: 'objektuSkaits',
                text: 'Objektu skaits',
                headerStyle: { width: '10%' }
            },
            {
                dataField: 'maksNovertejums',
                text: 'Maks. novērtējums',
                style: (cell) => ({ backgroundColor: getNovertejumsColor(cell) }),
                headerStyle: { width: '12%' }
            },
            {
                dataField: 'parametri',
                text: 'Parametri',
                headerStyle: { width: '63%' }
            }
        ];

        return (
            <div style={{ maxHeight: 'calc(100vh - 250px)', overflowY: 'auto' }}>
                <FormCard title="Monitoringa parametri" size={12}>
                    <h5 className="mt-3">Obligāti nosakāmie parametri</h5>
                    <p className="text-muted">
                        Riska objektu kategorijas ar maksimālo novērtējumu &ge; 10
                    </p>
                    {obligatas.length > 0 ? (
                        <BootstrapTable
                            keyField="id"
                            data={obligatas}
                            columns={parametriColumns}
                            bootstrap4 striped hover condensed
                        />
                    ) : (
                        <Alert color="info">Nav kategoriju ar maksimālo novērtējumu &ge; 10</Alert>
                    )}

                    <h5 className="mt-4">Rekomendējamie parametri</h5>
                    <p className="text-muted">
                        Riska objektu kategorijas ar maksimālo novērtējumu &lt; 10
                    </p>
                    {rekomendetasKat.length > 0 ? (
                        <BootstrapTable
                            keyField="id"
                            data={rekomendetasKat}
                            columns={parametriColumns}
                            bootstrap4 striped hover condensed
                        />
                    ) : (
                        <Alert color="info">Visas kategorijas ir ar augstu risku</Alert>
                    )}
                </FormCard>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    objekti: (state.riskaNovertejumi || {}).objektiList || []
});

export default connect(mapStateToProps, {
    loadRiskaNovertejumaParametri
})(RiskaNovertejumsParametri);
